import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import { Spdr } from "../Spdr";
import { TextFieldInput } from "../../../Forms/TextFieldInput";
import { isElementInArray } from "../../../Utils/arrays";
import { UPPERCASE_INPUT } from "../../../Forms/formStyles";
import { MdmFormProps } from "../../../Forms/MdmFormProps";

export const SpdrInformationForm = ({ disabledFields }: MdmFormProps) => {
  const { control } = useFormContext<Spdr>();

  return (
    <Grid container columnSpacing={3}>
      <Grid item xs={12}>
        <BorderedFormGrid>
          <Grid item xs={3}>
            <TextFieldInput
              name="SupplierGsdb"
              control={control}
              label="Supplier"
              required
              disabledFields={disabledFields}
              inputProps={UPPERCASE_INPUT}
            />
          </Grid>
          <Grid item xs={3}>
            <TextFieldInput
              name="PlantGsdb"
              control={control}
              label="Plant"
              required
              disabledFields={disabledFields}
              inputProps={UPPERCASE_INPUT}
            />
          </Grid>
          <Grid item xs={3}>
            <TextFieldInput
              name="DockCode"
              control={control}
              label="Dock"
              required
              disabledFields={disabledFields}
              inputProps={UPPERCASE_INPUT}
            />
          </Grid>
          {/* Placeholder */}
          <Grid item xs={3} />
        </BorderedFormGrid>

        <BorderedFormGrid>
          <Grid item xs={3}>
            <TextFieldInput
              name="CMMS3TransitTime"
              control={control}
              label="CMMS3 Transit Time"
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={3}>
            <TextFieldInput
              name="CMMS3ShipFrequency"
              control={control}
              label="CMMS3 Ship Frequency"
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={3}>
            <Controller
              name="PartExceptionRequired"
              control={control}
              render={({ field }) => (
                <FormControl
                  fullWidth
                  size="small"
                  disabled={isElementInArray(disabledFields, "PartExceptionRequired")}
                >
                  <InputLabel id="part-exception-required-label">
                    Part Exception Required
                  </InputLabel>
                  <Select
                    {...field}
                    labelId="part-exception-required-label"
                    label="Part Exception Required"
                  >
                    <MenuItem value={false as any}> No </MenuItem>
                    <MenuItem value={true as any}> Yes </MenuItem>
                  </Select>
                </FormControl>
              )}
            />
          </Grid>
          {/* Placeholder */}
          <Grid item xs={3} />
        </BorderedFormGrid>
      </Grid>
    </Grid>
  );
};
